import TrashIcon from '@ordr-as/icons/TrashIcon';
import { MenuAction } from '@ordr-as/umami-react/context-menu';
import type { Dispatch, SetStateAction } from 'react';
import { FormattedMessage } from 'react-intl';
import { useCartIsBusy } from '../../../../../hooks/useCartIsBusy';

interface EmptyCartMenuItemProps {
  setOpenEmptyCartDialog: Dispatch<SetStateAction<boolean>>;
}

const EmptyCartMenuItem = (props: EmptyCartMenuItemProps) => {
  const { setOpenEmptyCartDialog } = props;

  const cartIsBusy = useCartIsBusy();

  return (
    <MenuAction
      isDisabled={cartIsBusy}
      onClick={() => setOpenEmptyCartDialog(true)}
      className="umami-context-menu-item bg-brand-white text-small text-orange-darkest rounded-full py-4 px-4 pr-8"
    >
      <div className="flex text-base align-center text-brand-black">
        <TrashIcon className="text-orange-darkest mr-2 mt-1" />
        <span>
          <FormattedMessage id="generic.empty" />
        </span>
      </div>
    </MenuAction>
  );
};

export default EmptyCartMenuItem;
